import { motion } from "framer-motion";
import Link from "next/link";

export default function NavigationFooter() {
  return (
    <motion.div
      className="flex flex-col md:flex-row items-center justify-between py-12 border-t border-white/10 mt-20"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.7, delay: 0.2 }}
      data-cy="navigation"
    >
      <Link href="/work">
        <motion.button
          className="px-6 py-3 mb-6 md:mb-0 bg-transparent border border-white/30 rounded-lg text-white flex items-center group"
          whileHover={{
            x: -5,
            borderColor: "rgba(255, 136, 255, 0.5)",
            backgroundColor: "rgba(30, 11, 50, 0.3)"
          }}
          transition={{ duration: 0.2 }}
        >
          <motion.svg
            className="w-5 h-5 mr-3"
            viewBox="0 0 24 24"
            fill="none"
            initial={{ x: 0 }}
            animate={{ x: 0 }}
            transition={{ duration: 0.2 }}
          >
            <path d="M19 12H5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12 19L5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </motion.svg>
          <span className="relative">
            Zurück zu allen Projekten
            <motion.span
              className="absolute bottom-0 left-0 w-0 h-[1px] bg-white/50 group-hover:w-full"
              transition={{ duration: 0.3 }}
            />
          </span>
        </motion.button>
      </Link>

      <Link href="/contact">
        <motion.button
          className="px-6 py-3 bg-gradient-to-r from-[#1E0B32] to-[#2a1045] border border-[#ff88ff]/30 rounded-lg text-[#ff88ff] group"
          whileHover={{
            x: 5,
            scale: 1.05,
            boxShadow: "0 0 20px rgba(255, 136, 255, 0.2)"
          }}
          transition={{ duration: 0.2 }}
        >
          <span className="relative">
            Ein Projekt starten
            <motion.span
              className="absolute bottom-0 left-0 w-0 h-[1px] bg-[#ff88ff]/50 group-hover:w-full"
              transition={{ duration: 0.3 }}
            />
          </span>
          <motion.svg
            className="w-5 h-5 ml-3 inline-block"
            viewBox="0 0 24 24"
            fill="none"
            initial={{ x: 0 }}
            animate={{ x: 0 }}
            whileHover={{ x: 3 }}
            transition={{ duration: 0.2 }}
          >
            <path d="M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12 5L19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </motion.svg>
        </motion.button>
      </Link>
    </motion.div>
  );
}